import { Box, Tab, Tabs } from '@mui/material'

function CommonTabs({
  tabs = [],
  activeIndex = 0,
  actions = null,
  onTabChange,
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        backgroundColor: 'var(--bg-layer-1)',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '1px solid var(--border-subtel)',
      }}
    >
      <Tabs
        value={activeIndex}
        onChange={(_, index) => {
          onTabChange(index)
        }}
        slotProps={{
          indicator: {
            sx: {
              backgroundColor: 'var(--forbrand-color)',
              height: 4
            },
          },
        }}
      >
        {tabs.map((tab, index) => (
          <Tab
            key={tab.label}
            label={tab.label}
            value={index}
            sx={{
              '&.Mui-selected': {
                color: 'var(--forbrand-primary)',
                fontWeight: 700,
                borderLeft: 'none',
                borderRight: 'none',
                borderTop: 'none',
              },
              textTransform: 'none',
              fontWeight: 400,
              fontSize: '14px',
              color: 'var(--forbrand-secondary)',
            }}
          />
        ))}

      </Tabs>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          pr: 2,
        }}
      >
        {actions}
      </Box>
    </Box>
  )
}

export default CommonTabs
